import { PopupAlignment } from '../types'

export const popupAlignmentClass: Record<PopupAlignment, string> = {
  left: 'left-0',
  right: 'right-0',
  center: 'left-1/2 -translate-x-1/2',
}

export const getPopupAlignment = (
  rect: DOMRect,
  viewportWidth: number,
  margin = 8,
): PopupAlignment => {
  const hasLeftOverflow = rect.left < margin
  const hasRightOverflow = rect.right > viewportWidth - margin

  if (hasLeftOverflow && !hasRightOverflow) {
    return 'left'
  }

  if (!hasLeftOverflow && hasRightOverflow) {
    return 'right'
  }

  return 'center'
}
